import React from 'react';
import credits from '../../content/campus-credits.json';

export function getCampusImage(slug) {
  const entry = credits[slug];
  if (!entry) return null;
  return {
    ...entry,
    src640: `/campus/${slug}-640.webp`,
    src1600: `/campus/${slug}-1600.webp`
  };
}

function isOfficial(image) {
  return image.kind === 'official';
}

/** Short text credit, safe to place inside links. */
export function CampusCreditText({ slug, className = 'campus-credit' }) {
  const image = getCampusImage(slug);
  if (!image) return null;
  return (
    <span className={className}>
      {isOfficial(image)
        ? `Photo: courtesy of ${image.author}`
        : `Photo: ${image.author} · ${image.license}`}
    </span>
  );
}

/** Full credit with links to the licence and the original file. */
export function CampusCreditLinks({ slug, className = 'campus-credit' }) {
  const image = getCampusImage(slug);
  if (!image) return null;
  if (isOfficial(image)) {
    return (
      <p className={className}>
        Photo:{' '}
        <a href={image.pageUrl} target="_blank" rel="noopener noreferrer">
          courtesy of {image.author}
        </a>
      </p>
    );
  }
  return (
    <p className={className}>
      Photo:{' '}
      <a href={image.pageUrl} target="_blank" rel="noopener noreferrer">
        {image.author}
      </a>
      ,{' '}
      <a href={image.licenseUrl} target="_blank" rel="noopener noreferrer">
        {image.license}
      </a>
      , via Wikimedia Commons
    </p>
  );
}

/**
 * Responsive campus photo. Returns null when no openly licensed photo exists,
 * so callers fall back to the logo-only layout.
 */
export default function CampusImage({ slug, name, variant = 'card', className = '' }) {
  const image = getCampusImage(slug);
  if (!image) return null;
  const isHero = variant === 'hero';
  return (
    <img
      className={`campus-image campus-image-${variant} ${className}`.trim()}
      src={image.src640}
      srcSet={`${image.src640} ${image.smallWidth}w, ${image.src1600} ${image.width}w`}
      sizes={isHero ? '(min-width: 1100px) 800px, 100vw' : '(min-width: 900px) 360px, 100vw'}
      width={image.smallWidth}
      height={image.smallHeight}
      alt={`${name} campus`}
      loading={isHero ? 'eager' : 'lazy'}
      decoding="async"
      {...(isHero ? { fetchpriority: 'high' } : {})}
    />
  );
}
